import cytoscape from 'cytoscape';
import contextMenus from 'cytoscape-context-menus';
import { run as runActions } from '../../../store/workspaces/workspaces/run';
import store from '../../../store/store';
import { callFunctions } from '../../../api/functions/call.functions';

cytoscape.use(contextMenus);

export const contextMenu = (cy, contextData, addNodesCytoscape, removeNode, translate) => {
  const toArr = (v) => (Array.isArray(v) ? v : String(v ?? '').split(/\s+/).filter(Boolean));
  const mkClick = (def) => async (evt) => {
    if (!evt) return;
    const eventKey = def?.events?.find((e) => e.type === 'onClick')?.key;
    const selectedElements = JSON.parse(localStorage.getItem('selectedElements') || '[]');
    const data = selectedElements.length ? selectedElements : evt.target?.data?.();
    try {
      await runActions(eventKey, +evt.target?.data?.().id, { data });
      const activeData = store.getState().workspaces.instances.find((i) => i.isActive)?.data;
      callFunctions(activeData.functions, { addNodesCytoscape, removeNode, itemPosition: evt.position }, false);
    } catch (error) {
      console.log('Graph context menu error:', error);
    }
  };

  const getSubmenu = (item, translate) =>
    item.elements.map((it) => ({
      id: it?.key,
      content: translate(it?.label),
      show: true,
      onClickFunction: mkClick(it)
    }));

  const menuItems = contextData.elements.map((it) => {
    const cls = toArr(it.class);
    const hasDivider = cls.includes('divider');
    const disabled = cls.includes('disabled') || false;
    const show = cls.includes('hidden') || true;
    const onBackground = cls.includes('background');
    const parts = cls.filter((x) => x === 'node' || x === 'edge');
    const selector = onBackground ? undefined : (parts.length ? parts.join(', ') : 'node, edge');

    return {
      hasTrailingDivider: hasDivider,
      coreAsWell: onBackground,
      selector,
      disabled,
      id: it.key,
      content: translate(it.label),
      show,
      submenu: it.elements[0] !== null ? getSubmenu(it, translate) : null,
      onClickFunction: mkClick(it)
    };
  });

  return cy.contextMenus({ evtType: 'cxttap', menuItems });
};
